import { ValueOf } from 'type-fest';
import type { Price } from '../price/price.types';

export const types = {
  default: 'default',
  standalone: 'standalone',
} as const;

export type Summary = {
  information?: string;
  price?: Price;
  priceLabel?: string;
  rows: { label: string; value: string }[];
  testId?: string;
  title?: string;
  type?: ValueOf<typeof types>;
};
